// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__32iYe","label":"Section_label__QXnmb","contentWrap":"Section_contentWrap__3jMyW","footer":"Section_footer__24TnL","footerInner":"Section_footerInner__1mdxR"};